import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { Sidebar } from "../../components/sidebar/sidebar";

@Component({
  selector: 'app-sidebar-layout',
  imports: [RouterOutlet, Sidebar],
  templateUrl: './sidebar-layout.html',
  styleUrl: './sidebar-layout.css',
})
export class SidebarLayout {}
